import React from 'react';
import { Link } from 'react-router-dom';
import Item from './SidebarItem';

import LayoutContext from '../../../store/Layout/contexts';

import logo from '../../../assets/images/logos/hera-sidebar.png';

const Sidebar = ({
  type,
  items,
  currentUrlPath,
  setDropdownActive,
  dropdownActive,
}) => {
  return (
    <LayoutContext.Consumer>
      {({ activeSidebar, sidebarToggleHandler }) => (
        <>
        <aside className={`app-sidebar ${activeSidebar ? 'is-open' : 'is-collapsed'}`}>
          <Link
            to={'/'}
            className="app-sidebar-brand"
            aria-label="Heraa Solutions home"
          >
            <img
              src={logo}
              alt="Heraa Solutions"
            />
          </Link>
          <div className="app-sidebar-label">Workspace</div>
          <nav className="app-sidebar-nav" aria-label="Primary navigation">
          {items.map((item, index) => {
            if (
              (!item.auth && item.menu_auth) ||
              (item.auth && item.auth.some((level) => level === type)) ||
              item.menu_auth
            ) {
              return (
                <Item
                  key={index}
                  item={item}
                  currentUrlPath={currentUrlPath}
                  setDropdownActive={setDropdownActive}
                  dropdownActive={dropdownActive}
                />
              );
            }
            return null;
          })}
          </nav>
          <div className="app-sidebar-footer">
            <span className="app-sidebar-status" />
            <span className="app-sidebar-footer-text">Secure admin workspace</span>
          </div>
        </aside>
        {activeSidebar && (
          <button
            className="app-sidebar-backdrop"
            type="button"
            aria-label="Close navigation"
            onClick={sidebarToggleHandler}
          />
        )}
        </>
      )}
    </LayoutContext.Consumer>
  );
};

export default Sidebar;
